import React from 'react'
import { Tabbles } from '../../../components'
import { PiStethoscope } from 'react-icons/pi'
import { useTranslation } from 'react-i18next'

const Pending = ({ pendingData }) => {
    const { t } = useTranslation();
    return (
        <div className='pending-block'>
            <Tabbles.TableBlk
                headerIcon={<PiStethoscope className="header-Icn" />}
                heading={t("pending_request")}
                columns={[
                    `${t("no")}`,
                    `${t("specialist_name")}`,
                    `${t("phone_number")}`,
                    `${t("email")} ${t("Address")}`,
                    `${t("medical_specialty")}`,
                    // "Edit",
                    // "Delete",
                ]}
                data={pendingData?.map((pending, index) => ({
                    [t("no")]: index + 1,
                    [t("specialist_name")]: pending.doctorName,
                    [t("phone_number")]: pending.mobile,
                    [`${t("email")} ${t("Address")}`]: pending.email,
                    [t("medical_specialty")]: pending.speciality,
                    // Edit: (
                    //     <div className="editBlkIcon">
                    //         <FiEdit
                    //             // onClick={() => handleEditDefaultWorkingTime(Appointment)}
                    //             className="editIcon"
                    //         />
                    //     </div>
                    // ),
                    // Delete: (
                    //     <PiTrash
                    //         // onClick={() =>
                    //         //     handleDeleteDefaultWorkingTime(Appointment.defaultTimingGuid)
                    //         // }
                    //         className="delIcon noVerify"
                    //     />
                    // ),

                }))}
                tabbleClassname="tabble"
            />
        </div>

    )
}

export default Pending
